import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

export const campP7PoorRoasNew: FaireAdCampaignEntity = {
  token: "camp_p7_poor_roas_new",
  type: "adCampaign",
  advertiserProfileToken: "adv_p7_poor_roas",
  segment: "NEW_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 400,
  startedRunningAt: "2024-07-06",
  segmentMetrics: {
    numCustomersAcquired: 4,
    salesDollars: 559,
    totalAdsSpendDollars: 224,
    cpaDollars: 56,
    bestEstimateSalesDollars: 559,
    bestEstimateRoas: 2.5,
  },
  topCustomers: [
    {
      retailerName: "Hillside Market",
      storeType: "Farm store",
      location: "Leavenworth, WA",
      totalOrders: 1,
      totalAmountDollars: 180,
      lastOrderedAt: "2026-05-09",
    },
  ],
  performancePeriodTokens: [
    "perf_p7_poor_roas_new_202602",
    "perf_p7_poor_roas_new_202603",
    "perf_p7_poor_roas_new_202604",
    "perf_p7_poor_roas_new_202605",
    "perf_p7_poor_roas_new_202606",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
